// extracted by mini-css-extract-plugin
module.exports = {"tooltipArrow":"_5c7bdc3","buttonContainer":"_c0d3d59","embeddedContainer":"_1b85212","advanced":"_f221bb3","create":"_6754600","back":"_f73e1a1","hidden":"_a728709"};